const EN = {
  title: 'Payment',
  cardHolderName: 'Card Holder Name',
  cardHolderNamePlaceholder: 'Enter card holder name',
  cardNumber: 'Card Number',
  cardNumberPlaceholder: 'Enter card number',
  expiryDate: 'Expiry Date',
  expiryDateHelperText:
    'you should be able to find this date on the front of your card, under the card number',
  cvv: 'CVV',
  cvvHelperText:
    'A code on your Credit card that you could find on the back of your card',
  cvvPlaceholder: '123',
  rememberMeText: 'Save your Card details for Faster and secure checkout',
  total: 'Total',
  taxes: ' (Including taxes & delivery)',
  payNow: 'Pay Now',
  transactionFailedTitle: 'Transaction Failed',
  transactionFailedText:
    'Transaction amount is either bigger than maximum or less than minimum amount accepted for the selected plan',
  transactionFailedAction: 'Try Again',
  informativeModalButtonText: 'Ok',
  required: 'required',
  cardNameCharactersValidation: 'Name must contain characters only',
  cardFullNameValidation: 'Full name must contain at least 2 names',
  expiryDateValidation: 'Expired card',
  invalidDate: 'Invalid date',
  cvv_invalid: 'Invalid CVV',
  card_number_invalid: 'Card number is invalid',
  plan_price: 'Plan Price',
  vat: 'VAT',
  promoted_bank_discount:
    '{{promotedBankName}} Discount {{discountAmount}}{{type}} off, {{extraNote}}',
  program_discount: 'Business Discount',
  addon: 'Addon',
  wallet: 'Wallet',
  rajhi_mokafaa: 'Alrajhi Mokafa’a',
};
export default EN;
